import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Http } from '@angular/http';
import { of } from 'rxjs/observable/of';
import { CandidateService } from '../candidate/candidate.service';

@Injectable()
export class MedicalCaseEventCandidateSharedService {

    private candidate: any;
    public candidateSubject = new BehaviorSubject<any>(null);

    constructor(private http: Http,
                public candidateService: CandidateService) { }

    fetchDataById(id: string): Observable<any> {
      if (this.candidate && (this.candidate.id === id || this.candidate.candidate_id)) {
        return of(this.candidate); // Retornar datos almacenados si están disponibles
      } else {
        return this.candidateService.infoCandidateSmall(parseInt(id))
          .map(response => {
            this.candidate = response.json();
            this.candidateSubject.next(this.candidate);
            return this.candidate;
          });
      }
    }
  
    getCandidateObservable(): Observable<any> {
      return this.candidateSubject.asObservable();
    }
  
    setCandidate(newCandidate: any) {
      this.candidate = newCandidate;
      this.candidateSubject.next(this.candidate);
    }
  }


// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/medical-case-event-candidate/medical-case-event-candidate-shared.service.ts